export var MeshName;
(function (MeshName) {
    MeshName["backgroundSkybox"] = "BackgroundSkybox";
    MeshName["fadingSkybox"] = "fadingSkybox";
    MeshName["backgroundPlane"] = "BackgroundPlane";
    MeshName["fpsMesh"] = "fpsMesh";
    MeshName["projectionMeshLeft"] = "ProjectionMeshLeft";
    MeshName["projectionMeshRight"] = "ProjectionMeshRight";
    MeshName["notificationCenter"] = "notificationCenterMesh";
    MeshName["messageDialog"] = "messageDialog";
    MeshName["sendTipDialog"] = "sendTipDialog";
    MeshName["toyTipDialog"] = "toyTipDialog";
    MeshName["messageSelectorDialog"] = "messageSelectorDialog";
    MeshName["broadcastBackupPhoto"] = "broadcastBackupPhoto";
    MeshName["broadcastMenuPanelNavigation"] = "broadcastMenuPanelNavigation";
    MeshName["broadcastMenuSubmenuVolume"] = "broadcastMenuSubmenuVolume";
    MeshName["broadcastMenuSubmenuStreams"] = "broadcastMenuSubmenuStreams";
    MeshName["broadcastMenuSubmenuClientProfile"] = "broadcastMenuSubmenuClientProfile";
    MeshName["broadcastSubtitlesPanel"] = "broadcastSubtitlesPanel";
    MeshName["broadcastSubtitlesLanguageList"] = "broadcastSubtitlesLanguageList";
    MeshName["broadcastSubtitlesDragHandle"] = "broadcastSubtitlesDragHandle";
    MeshName["lobbyKeyboard"] = "lobbyKeyboardMesh";
    MeshName["lobbyHideKeyboard"] = "lobbyHideKeyboardMesh";
    MeshName["broadcastMenuPanelModel"] = "broadcastMenuPanelModel";
    MeshName["broadcastMenuPanelModelProfile"] = "broadcastMenuPanelModelProfile";
    // broadcastMenuPanelClient = "broadcastMenuPanelClient",
    MeshName["broadcastMenuPanelTipMenu"] = "broadcastMenuPanelTipMenu";
    MeshName["broadcastMenuPanelTips"] = "broadcastMenuPanelTips";
    MeshName["broadcastMenuPanelMode"] = "broadcastMenuPanelMode";
    MeshName["broadcastMenuPanelChat"] = "broadcastMenuPanelChat";
    MeshName["broadcastMenuPanelUser"] = "broadcastMenuPanelUser";
    MeshName["broadcastTipsKeyboard"] = "broadcastTipsKeyboardMesh";
    MeshName["broadcastMenuPanelPrivateMode"] = "broadcastMenuPanelPrivateMode";
    MeshName["lockedVideoCoverPanel"] = "lockedVideoCoverPanel";
    MeshName["videoMenuMainPanel"] = "videoMenuMainPanel";
    MeshName["videoMenuRecommendedVideosPanel"] = "videoMenuRecommendedVideosPanel";
    MeshName["videoMenuInfoPanel"] = "videoMenuInfoPanel";
    MeshName["videoMenuHelpPanel"] = "videoMenuHelpPanel";
    MeshName["loginForm"] = "loginFormMesh";
    MeshName["loginFormKeyboard"] = "loginFormKeyboardMesh";
    MeshName["lobbyMessengerPanel"] = "lobbyMessengerPanel";
    MeshName["lobbyMessengerChatListPanel"] = "lobbyMessengerChatListPanel";
    MeshName["lobbyMessengerEllipsisSubmenu"] = "lobbyMessengerEllipsisSubmenu";
    MeshName["lobbyMessengerTipsKeyboardPanel"] = "lobbyMessengerTipsKeyboardPanel";
    MeshName["lobbyMessengerLinkWarningDialog"] = "lobbyMessengerLinkWarningDialog";
    MeshName["broadcastMessengerPanel"] = "broadcastMessengerPanel";
    MeshName["broadcastMessengerChatListPanel"] = "broadcastMessengerChatListPanel";
    MeshName["broadcastMessengerEllipsisSubmenu"] = "broadcastMessengerEllipsisSubmenu";
    MeshName["broadcastMessengerTipsKeyboardPanel"] = "broadcastMessengerTipsKeyboardPanel";
    MeshName["broadcastMessengerLinkWarningDialog"] = "broadcastMessengerLinkWarningDialog";
    MeshName["videoClipMessengerPanel"] = "videoClipMessengerPanel";
    MeshName["videoClipMessengerChatListPanel"] = "videoClipMessengerChatListPanel";
    MeshName["videoClipMessengerEllipsisSubmenu"] = "videoClipMessengerEllipsisSubmenu";
    MeshName["videoClipMessengerTipsKeyboardPanel"] = "videoClipMessengerTipsKeyboardPanel";
    MeshName["videoClipMessengerLinkWarningDialog"] = "videoClipMessengerLinkWarningDialog";
    MeshName["environmentForm"] = "environmentFormMesh";
    MeshName["voiceToTextAnimationPanel"] = "voiceToTextAnimationPanel";
    MeshName["lobbyTags"] = "lobbyTags";
    // lobbyLiveTags = "lobbyLiveTags",
    // lobbyVideoTags = "lobbyVideoTags",
    // lobbyMode = "lobbyMode",
    MeshName["complimentDialog"] = "complimentDialog";
    MeshName["complimentMessageDialog"] = "complimentMessageDialog";
    MeshName["complimentTipsKeyboard"] = "complimentTipsKeyboard";
    MeshName["onboardingMesh"] = "onboardingMesh";
    MeshName["onboardingBlockerMesh"] = "onboardingBlockerMesh";
    MeshName["upcomingEventsPanel"] = "upcomingEventsPanel";
    MeshName["upcomingEventsHeader"] = "upcomingEventsHeader";
    MeshName["modelsPanel"] = "modelsPanel";
    MeshName["selectedModelPanel"] = "selectedModelPanel";
    MeshName["lobbyUserPanel"] = "lobbyUserPanel";
    MeshName["lobbyUserExtraPanel"] = "lobbyUserExtraPanel";
    MeshName["lobbyUserSignoutPanel"] = "lobbyUserSignoutPanel";
    MeshName["broadcastMenuDragAndDropControl"] = "broadcastMenuDragAndDropControl";
    MeshName["videoClipMenuDragAndDropControl"] = "videoClipMenuDragAndDropControl";
    MeshName["dropdownSlider"] = "dropdownSlider";
    MeshName["broadcastMenuHelpPanel"] = "broadcastMenuHelpPanel";
    MeshName["progressBar"] = "progressBar";
    MeshName["broadcastChatKeyboard"] = "broadcastChatKeyboardMesh";
    MeshName["hideBroadcastChatKeyboard"] = "hideBroadcastChatKeyboard";
    MeshName["videoClipChatKeyboard"] = "videoClipChatKeyboardMesh";
    MeshName["hideVideoClipChatKeyboard"] = "hideVideoClipChatKeyboard";
    MeshName["relatedBroadcastCarouselMenu"] = "relatedBroadcastCarouselMenu";
    MeshName["relatedBroadcastCarouselItem0"] = "relatedBroadcastCarouselItem0";
    MeshName["relatedBroadcastCarouselItem1"] = "relatedBroadcastCarouselItem1";
    MeshName["relatedBroadcastCarouselItem2"] = "relatedBroadcastCarouselItem2";
    MeshName["relatedBroadcastCarouselItem3"] = "relatedBroadcastCarouselItem3";
    MeshName["relatedBroadcastCarouselItem4"] = "relatedBroadcastCarouselItem4";
    MeshName["relatedBroadcastCarouselItem5"] = "relatedBroadcastCarouselItem5";
    MeshName["broadcastMenuPanelRelated"] = "broadcastMenuPanelRelated";
})(MeshName || (MeshName = {}));
export const UiMeshNames = [
    MeshName.fadingSkybox,
    MeshName.notificationCenter,
    MeshName.messageDialog,
    MeshName.sendTipDialog,
    MeshName.toyTipDialog,
    MeshName.messageSelectorDialog,
    MeshName.broadcastBackupPhoto,
    MeshName.broadcastMenuPanelNavigation,
    MeshName.broadcastMenuSubmenuVolume,
    MeshName.broadcastMenuSubmenuStreams,
    MeshName.broadcastMenuSubmenuClientProfile,
    MeshName.broadcastSubtitlesPanel,
    MeshName.broadcastMenuPanelModel,
    // MeshName.broadcastMenuPanelClient,
    MeshName.broadcastMenuPanelTipMenu,
    MeshName.broadcastMenuPanelModelProfile,
    MeshName.broadcastMenuPanelTips,
    MeshName.broadcastMenuPanelMode,
    MeshName.broadcastMenuPanelChat,
    MeshName.broadcastMenuPanelUser,
    MeshName.lockedVideoCoverPanel,
    MeshName.videoMenuMainPanel,
    MeshName.videoMenuRecommendedVideosPanel,
    MeshName.videoMenuInfoPanel,
    MeshName.videoMenuHelpPanel,
    MeshName.broadcastTipsKeyboard,
    MeshName.loginForm,
    MeshName.loginFormKeyboard,
    MeshName.lobbyMessengerPanel,
    MeshName.lobbyMessengerChatListPanel,
    MeshName.lobbyMessengerEllipsisSubmenu,
    MeshName.lobbyMessengerTipsKeyboardPanel,
    MeshName.lobbyMessengerLinkWarningDialog,
    MeshName.broadcastMessengerPanel,
    MeshName.broadcastMessengerChatListPanel,
    MeshName.broadcastMessengerEllipsisSubmenu,
    MeshName.broadcastMessengerTipsKeyboardPanel,
    MeshName.broadcastMessengerLinkWarningDialog,
    MeshName.videoClipMessengerPanel,
    MeshName.videoClipMessengerChatListPanel,
    MeshName.videoClipMessengerEllipsisSubmenu,
    MeshName.videoClipMessengerTipsKeyboardPanel,
    MeshName.videoClipMessengerLinkWarningDialog,
    MeshName.lobbyKeyboard,
    MeshName.lobbyHideKeyboard,
    MeshName.environmentForm,
    MeshName.broadcastMenuPanelPrivateMode,
    MeshName.voiceToTextAnimationPanel,
    MeshName.lobbyTags,
    // MeshName.lobbyLiveTags,
    // MeshName.lobbyVideoTags,
    // MeshName.lobbyMode,
    MeshName.complimentDialog,
    MeshName.complimentMessageDialog,
    MeshName.complimentTipsKeyboard,
    MeshName.lobbyUserPanel,
    MeshName.lobbyUserExtraPanel,
    MeshName.lobbyUserSignoutPanel,
    MeshName.broadcastMenuDragAndDropControl,
    MeshName.videoClipMenuDragAndDropControl,
    MeshName.broadcastChatKeyboard,
    MeshName.hideBroadcastChatKeyboard,
    MeshName.videoClipChatKeyboard,
    MeshName.hideVideoClipChatKeyboard,
    MeshName.dropdownSlider,
    MeshName.broadcastMenuHelpPanel,
    MeshName.relatedBroadcastCarouselMenu,
    MeshName.relatedBroadcastCarouselItem0,
    MeshName.relatedBroadcastCarouselItem1,
    MeshName.relatedBroadcastCarouselItem2,
    MeshName.relatedBroadcastCarouselItem3,
    MeshName.relatedBroadcastCarouselItem4,
    MeshName.relatedBroadcastCarouselItem5,
    MeshName.broadcastMenuPanelRelated,
    MeshName.broadcastSubtitlesPanel,
    MeshName.broadcastSubtitlesLanguageList,
    MeshName.broadcastSubtitlesDragHandle,
];
